import { Spin } from 'antd';

// 内容区域内居中的加载态
const ContentLoading = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        width: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default ContentLoading;
